export default __webpack_public_path__ + "static/media/happy.f5788f81.svg";